// extracted by mini-css-extract-plugin
module.exports = {"scrollContainer":"Marquee_scrollContainer__2G8yN","scrollText":"Marquee_scrollText__QSwlv","scroll":"Marquee_scroll__2svTD"};